<template>
  <el-card>
    <div slot="header" class="toolbar">
      <span>报废管理</span>
    </div>

    <div class="search-bar search-wrap">
      <el-input
        v-model.trim="query.orderNo"
        placeholder="请输入订单号"
        clearable
        style="width: 220px"
        @keyup.enter.native="handleSearch"
      />
      <el-input
        v-model.trim="query.afterSaleNo"
        placeholder="请输入售后单号"
        clearable
        style="width: 220px"
        @keyup.enter.native="handleSearch"
      />
      <el-input
        v-model.trim="query.goodsName"
        placeholder="请输入商品名称"
        clearable
        style="width: 220px"
        @keyup.enter.native="handleSearch"
      />
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-table :data="list" border style="width: 100%">
      <el-table-column prop="afterSaleNo" label="售后单号" width="180" align="center" />
      <el-table-column prop="orderNo" label="原订单号" width="180" align="center" />
      <el-table-column prop="goodsName" label="商品名称" min-width="220" align="center" show-overflow-tooltip />
      <el-table-column prop="applyQuantity" label="报废数量" width="100" align="center" />
      <el-table-column label="售后类型" width="120" align="center">
        <template slot-scope="{ row }">
          {{ afterSaleTypeText(row.afterSaleType) }}
        </template>
      </el-table-column>
      <el-table-column prop="scrapTime" label="报废时间" width="170" align="center" />
      <el-table-column label="操作" width="180" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" @click="openDetail(row)">详情</el-button>
          <el-button
            v-if="$hasPermission('mall:order-scrap:cancel', 'mall:order-scrap:list')"
            size="mini"
            type="warning"
            @click="cancelScrap(row)"
          >
            取消报废
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="query.page"
        :page-size="query.limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog title="报废详情" :visible.sync="detailVisible" width="760px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="售后单号">{{ detail.afterSaleNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="原订单号">{{ detail.orderNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="换货订单号">{{ detail.exchangeOrderNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="售后类型">{{ afterSaleTypeText(detail.afterSaleType) }}</el-descriptions-item>
        <el-descriptions-item label="用户昵称">{{ detail.nickname || '-' }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ detail.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{ detail.goodsName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="SKU">{{ detail.skuName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="规格">{{ detail.specText || '-' }}</el-descriptions-item>
        <el-descriptions-item label="换货目标规格">{{ exchangeSkuText(detail) }}</el-descriptions-item>
        <el-descriptions-item label="报废数量">{{ detail.applyQuantity || 0 }}</el-descriptions-item>
        <el-descriptions-item label="库存状态">{{ stockRollbackText(detail.stockRollbackStatus) }}</el-descriptions-item>
        <el-descriptions-item label="报废时间">{{ detail.scrapTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="取消报废时间">{{ detail.cancelScrapTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detail.createTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="审核说明" :span="2">{{ detail.adminRemark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="报废说明" :span="2">{{ detail.scrapRemark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../../utils/http'

function defaultQuery () {
  return {
    page: 1,
    limit: 10,
    orderNo: '',
    afterSaleNo: '',
    goodsName: ''
  }
}

export default {
  data () {
    return {
      query: defaultQuery(),
      list: [],
      total: 0,
      detailVisible: false,
      detail: {}
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      const { data } = await http.get('/mall/order/scrap/list', { params: this.query })
      const pageData = data.data || {}
      this.list = pageData.list || []
      this.total = Number(pageData.total || 0)
    },
    handleSearch () {
      this.query.page = 1
      this.load()
    },
    handlePageChange (page) {
      this.query.page = page
      this.load()
    },
    handleSizeChange (limit) {
      this.query.limit = limit
      this.query.page = 1
      this.load()
    },
    reset () {
      this.query = defaultQuery()
      this.load()
    },
    afterSaleTypeText (value) {
      const map = { 1: '退积分', 2: '退货退积分', 3: '换货' }
      return map[value] || '-'
    },
    exchangeSkuText (row) {
      if (!row || Number(row.afterSaleType) !== 3) return '-'
      return row.exchangeSpecText || row.exchangeSkuName || row.exchangeSkuNo || '-'
    },
    stockRollbackText (value) {
      return Number(value) === 1 ? '已回滚库存' : '未回滚库存'
    },
    openDetail (row) {
      this.detail = row || {}
      this.detailVisible = true
    },
    async cancelScrap (row) {
      await this.$confirm(
        `确定取消报废售后单「${row.afterSaleNo}」吗？取消后会回滚对应商品库存。`,
        '取消报废确认',
        { type: 'warning', confirmButtonText: '确认取消报废', cancelButtonText: '再想想' }
      )
      const { data } = await http.post(`/mall/order/scrap/cancel/${row.id}`)
      if (data.code === 0) {
        this.$message.success('已取消报废并回滚库存')
        this.load()
      }
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.search-wrap {
  flex-wrap: wrap;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
